import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ArrowRight, Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/Forms";
import { Brand } from "@/components/Brand";
import { useStore } from "@/store/AppStore";
import { apiError } from "@/lib/api";

export const HOME = { master: "/master", empresaria: "/empresaria", colaboradora: "/colaboradora" };

export const FullLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-white" data-testid="app-loading"><Loader2 className="h-6 w-6 animate-spin text-gold" /></div>
);

function LoginForm() {
  const { login } = useStore();
  const navigate = useNavigate();
  const [f, setF] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(f.username.trim(), f.password);
      navigate(HOME[u.role]);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
      <Field label="Usuário"><Input autoComplete="username" autoCapitalize="none" placeholder="ex.: ana.bella" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} data-testid="login-username-input" /></Field>
      <Field label="Senha"><Input type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password-input" /></Field>
      {error && <p className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="login-error">{error}</p>}
      <Button type="submit" disabled={busy || !f.username || !f.password} className="h-11 w-full font-semibold" data-testid="login-submit-button">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Entrar <ArrowRight className="ml-1.5 h-4 w-4" /></>}
      </Button>
    </form>
  );
}

export default function Login() {
  const { user } = useStore();
  if (user === null) return <FullLoader />;
  if (user) return <Navigate to={HOME[user.role]} replace />;
  return (
    <div className="grid min-h-screen bg-white lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:block">
        <img src="/img/login-bg.jpg" alt="" className="absolute inset-0 h-full w-full object-cover object-[30%_center]" />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/70 via-neutral-950/10 to-transparent" />
        <div className="absolute bottom-0 left-0 p-14 text-white">
          <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-white/90 drop-shadow">Consultoria e gestão empresarial</p>
          <h2 className="max-w-md font-display text-4xl font-semibold leading-tight">Estratégias inteligentes, processos organizados, equipe treinadas e resultados que brilham</h2>
        </div>
      </div>
      <div className="flex flex-col justify-center px-6 py-12 sm:px-14 lg:px-20">
        <div className="fade-in w-full max-w-md">
          <Brand large />
          <h1 className="mt-14 font-display text-3xl font-semibold tracking-tight text-neutral-900 sm:text-4xl">Bem-vinda de volta</h1>
          <p className="mt-3 text-sm text-neutral-500">Entre com o usuário e a senha recebidos da sua consultora ou empresária.</p>
          <LoginForm />
          <p className="mt-10 flex items-center gap-2 border-t border-neutral-100 pt-6 text-xs text-neutral-400"><Lock className="h-3.5 w-3.5 text-gold" /> Esqueceu a senha? Peça para a consultora ou a empresária redefinir.</p>
        </div>
      </div>
    </div>
  );
}
